// extracted by mini-css-extract-plugin
export default {"contain":"G-","textContain":"H-","bold":"I-"};
    if(module.hot) {
      // 1711394580144
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  